// src/utils/helpers.js

/* ---------------- DATE FORMATTERS ---------------- */

export function formatDate(date) {
  if (!date) return "—";
  try {
    return new Intl.DateTimeFormat("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    }).format(new Date(date));
  } catch {
    return "—";
  }
}

export function formatDateTime(date) {
  if (!date) return "—";
  try {
    return new Intl.DateTimeFormat("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    }).format(new Date(date));
  } catch {
    return "—";
  }
}

/* ---------------- MONEY ---------------- */

export function moneyINR(amount = 0) {
  const value = Number(amount) || 0;
  try {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 0,
    }).format(value);
  } catch {
    return `₹${value}`;
  }
}

/* ---------------- STRING UTILS ---------------- */

export function asLower(str) {
  return String(str ?? "").toLowerCase();
}

/* ---------------- JSON SAFE PARSE ---------------- */

export function safeJsonParse(text) {
  try {
    return JSON.parse(text);
  } catch {
    return null;
  }
}

/* ---------------- CLASS NAME MERGE ---------------- */

export function cn(...classes) {
  return classes.filter(Boolean).join(" ");
}

/* ---------------- CLAIM STATS ---------------- */

export function calculateDeviceClaimStats(claims = [], deviceId) {
  const rows = claims.filter((c) => c.device_id === deviceId);

  const total = rows.length;
  const approved = rows.filter(
    (c) => c.approval?.status === "approved"
  ).length;
  const rejected = rows.filter(
    (c) => c.approval?.status === "rejected"
  ).length;
  const open = rows.filter((c) => {
    const last = c.status_history?.[c.status_history.length - 1];
    return last?.key !== "closed" && c.approval?.status !== "rejected";
  }).length;

  return { total, approved, rejected, open, rows };
}
